import { useMutation, useQueryClient } from '@tanstack/react-query'

import { ErrorResponse } from '@sparkai/utils'

import { apiClient } from '../../../apiClient'
import { USE_GET_PROGRAM_ONTOLOGY_KEY } from '../useGetCurrentProgramOntologyConfig'
import {
  CriticalErrorMatrix,
  USE_ONTOLOGY_PREDICTION_CORRECTION_CRITICAL_ERRORS_KEY,
} from './useGetOntologyPredictionCorrectionCriticalErrors'

export function useEditOntologyPredictionCorrectionCriticalErrors(
  programId?: string,
  predictionCorrectionId?: string,
  onSuccess?: () => void
) {
  const queryClient = useQueryClient()

  return useMutation<CriticalErrorMatrix, ErrorResponse, CriticalErrorMatrix>({
    mutationFn: async (values: CriticalErrorMatrix) => {
      const { data } = await apiClient.put<CriticalErrorMatrix>(
        `/int/v3/programs/${programId}/ontology/prediction-corrections/${predictionCorrectionId}/critical-errors`,
        values
      )
      return data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [USE_GET_PROGRAM_ONTOLOGY_KEY] })
      queryClient.invalidateQueries({ queryKey: [USE_ONTOLOGY_PREDICTION_CORRECTION_CRITICAL_ERRORS_KEY] })

      onSuccess?.()
    },
  })
}
